import React from "react";
import "../admin/style/Coustom.css";


const setupCards = [
  {
    title:"User & Profile",
    desc:"Manage user accounts, roles, and access profiles.",
    icon:"👤",
    color:"blue"
  },
  {
    title:"Course Structure",
    desc:"Setup and update fee structures by class/course.",
    icon:"📚",
    color:"blue"
  },
  {
    title:"Student Onboarding",
    desc:"Register new student profiles and demographic details.",
    icon:"👥",
    color:"green"
  }
];


const operationCards = [
  {
    title:"Recurring Payments",
    desc:"Track and record monthly/termly fee collections.",
    icon:"📅",
    color:"blue"
  },
  {
    title:"Fee Adjustments",
    desc:"Manage all student fee structures and special cases.",
    icon:"🏷️",
    color:"red"
  },
  {
    title:"Financial Analytics",
    desc:"Generate detailed payment, outstanding, and collection reports.",
    icon:"📈",
    color:"purple"
  },
  {
    title:"Student Roster",
    desc:"View, search, and update active student profiles.",
    icon:"☷",
    color:"green"
  }
];




const DashboardContent = () => {


return (

<div className="dashboard-container">


{/* TOP HEADER */}

<div className="welcome-box">


<div>

<p className="suite">
● FEES MANAGEMENT SUITE
</p>


<h1>
Welcome back, 
<span> Orisys</span>
</h1>


<p className="sub">
Here's a quick overview of everything you can manage today.
</p>


</div>



<div className="date-box">

<div className="clock">
◷
</div>


<div>
<p>
Tuesday, July 28, 2026
</p>

<h3>
4:02 PM
</h3>

</div>


</div>


</div>





{/* SECTION 1 */}

<DashboardSection
title="SETUP & ENROLLMENT"
data={setupCards}
/>





{/* SECTION 2 */}

<DashboardSection
title="FEES & OPERATIONS"
data={operationCards}
/>










</div>

);

};





const DashboardSection = ({title,data}) => {


return (

<div className="section">


<h3 className="section-title">

<span>
☷
</span>

{title}

</h3>




<div className="cards">


{
data.map((item,index)=>(


<div className="dashboard-card" key={index}>


<div className={`card-icon ${item.color}`}>

{item.icon}

</div>



<h2>
{item.title}
</h2>



<p>
{item.desc}
</p>



<a>
Open →
</a>


</div>


))
}



</div>



</div>


);


};




export default DashboardContent;